import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaManifestService } from '@madeinlune/ngx-pwa-manifest';
import { map, Observable } from 'rxjs';
import { LetModule, PushModule } from '@ngrx/component';
import { TranslocoModule } from '@ngneat/transloco';
import { DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponentModule } from '@nx-icilalune/icilalune/media';

export type LanguageSwitcherResult = 'stay' | 'switch';

@Component({
  selector: 'nx-icilalune-language-switcher',
  standalone: true,
  imports: [
    CommonModule,
    LetModule,
    TranslocoModule,
    PushModule,
    SvgIconComponentModule,
  ],
  template: `
    <ng-container *transloco="let t">
      <div class="b-title">
        <i2l-svg-icon [icon]="'globe'"></i2l-svg-icon>
        <h2 [innerHTML]="t('languages.switcher.title')"></h2>
      </div>
      <p [innerHTML]="t('languages.switcher.description')"></p>
      <div class="b-actions">
        <button class="lune-btn" (click)="onStay()">
          <span [innerHTML]="t('languages.switcher.stay')"></span>
        </button>
        <button class="lune-btn" (click)="onSwitch()">
          <span [innerHTML]="t('languages.switcher.go')"></span>
        </button>
      </div>
    </ng-container>
  `,
  styleUrls: ['./language-switcher.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent {
  iconUrl$: Observable<string | undefined> =
    this.pwaManifestService.icons$.pipe(
      map((icons) => {
        return icons.find((icon) => icon.sizes === '192x192')?.src;
      })
    );

  constructor(
    private pwaManifestService: PwaManifestService,
    private dialogRef: DialogRef<LanguageSwitcherResult>
  ) {}

  onStay() {
    this.dialogRef.close('stay');
  }

  onSwitch() {
    this.dialogRef.close('switch');
  }
}
